import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TFormErrorMessageProps } from '@/shared/components/ui/form/components/form-error-message/form-error-message.types';
import { DEFAULT_ERROR_KEY } from '@/shared/utils/validation';

export const FormErrorMessage: React.FC<TFormErrorMessageProps> = ({
  field,
  errorMessage,
}) => {
  const {
    t,
    i18n: { exists },
  } = useTranslation();

  const renderMessage = () => {
    const key = `error:${errorMessage}`;
    if (errorMessage && errorMessage !== DEFAULT_ERROR_KEY && exists(key)) {
      return t(key);
    }

    return t('ui:form.field_required', {
      field: field ? field : t('ui:form.field'),
    });
  };

  return (
    <Typography marginTop=".5rem" variant="p9" color="status.red.text">
      {renderMessage()}
    </Typography>
  );
};
